import CgEditForm from '../EditForm/index.js';
import EditPanelMixin from './EditPanelMixin';
import EditPanelSkeleton from './EditPanelSkeleton';
import zhCN from 'ant-design-vue/lib/locale-provider/zh_CN';

const SLOT_KEY_RG = /^layout/;

export default {
    mixins: [EditPanelMixin],
    props: {
        scrollTarget: {
            type: Function,
            default: () => null
        }
    },
    data() {
        return {
            IsCustomLayoutMode: false
        };
    },
    computed: {
        Locale: function() {
            return zhCN;
        },
        Layout: function() {
            return this.CurUserForm.LayoutCfg;
        }
    },
    methods: {
        ToggleIsCustomLayoutMode() {
            this.IsCustomLayoutMode = !this.IsCustomLayoutMode;
        }
    },
    render(h) {
        // 表单
        const _editForm = this.IsInEditTemplate ? (
            <div>
                <CgEditForm
                    class="cmn-detault-control-container"
                    v-model={this.CurRecData}
                    col-info={this.ColInfoEdit}
                    layout={this.Layout}
                    is-custom-layout-mode={this.IsCustomLayoutMode}
                    scopedSlots={Object.keys(this.$scopedSlots)
                        .filter(key => SLOT_KEY_RG.test(key))
                        .reduce((slots, key) => {
                            slots[key] = this.$scopedSlots[key];
                            return slots;
                        }, {})}
                />
            </div>
        ) : null;

        return (
          <a-config-provider locale={this.Locale}>
            <EditPanelSkeleton
                scrollTarget={this.scrollTarget}
                scopedSlots={{
                    extra: () => (
                        <a-button
                            type="link"
                            v-show={this.IsSysAdmin}
                            icon="layout"
                            onClick={this.ToggleIsCustomLayoutMode}
                        />
                    )
                }}
            >
                {_editForm}

                {this.$slots.default}
            </EditPanelSkeleton>
          </a-config-provider>
        );
    }
};
